/**
 * PageSpinner — Full-page centered loading spinner
 * Wraps shadcn Spinner with consistent layout for page/section loading states.
 */

import React from "react";
import { Spinner } from "../ui/spinner";
import { cn } from "@/lib/utils";

export interface PageSpinnerProps {
  label?: string;
  size?: string;
  className?: string;
}

export function PageSpinner({ label = "Loading", size = "size-9", className }: PageSpinnerProps) {
  return (
    <div
      role="progressbar"
      aria-label={label}
      className={cn("flex items-center justify-center min-h-[30vh]", className)}
    >
      <Spinner className={cn("text-brand-navy", size)} />
    </div>
  );
}

export default PageSpinner;
